import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const Title = styled.h1`
  color: ${customPalette.grey.main};
  font-size: 32px;
  font-weight: 700;
  line-height: 150%;
  margin-top: 36px;
  text-align: center;
`;

export const MainContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin: 20px;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const Select = styled.select`
  padding: 10px;
  border-radius: 5px;
  background-color: #f8f9fa;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #e9ecef;
  }

  &:focus {
    outline: none;
    border-color: #0056b3;
    background-color: #fff;
  }
`;

export const OptionStyle = styled.option`
  font-size: 14px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

export const TableHeader = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  background-color: #f2f2f2;
  text-align: left;
`;

export const TableRow = styled.tr`
  &:nth-of-type(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

export const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const StatusText = styled.span<{ isValid: boolean }>`
  color: ${(props) => (props.isValid ? 'green' : 'red')};
  font-weight: bold;
`;
